import React, {useState, useEffect, useRef} from 'react';
import {useNavigate} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import {ConfirmDialog} from "primereact/confirmdialog";
import axios from "axios";
import Cookies from "js-cookie";

const _FM_GirpadditionalfieldcollectionListComponent = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const [collections, setCollections] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(10);
  const dt = useRef(null);
  const [lazyParams, setLazyParams] = useState({
    first: Number(localStorage.getItem('girpAdditionalFieldCollection_first')) || 0,
    rows: Number(localStorage.getItem('girpAdditionalFieldCollection_rows')) || rows,
    page: Number(localStorage.getItem('girpAdditionalFieldCollection_page')) || 0,
    sortField: localStorage.getItem('girpAdditionalFieldCollection_sortField') || 'id',
    sortOrder: Number(localStorage.getItem('girpAdditionalFieldCollection_sortOrder')) || -1,
    filters: JSON.parse(localStorage.getItem('girpAdditionalFieldCollection_filters')) || null,
  });

  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }

    loadLazyTimeout = setTimeout(() => {
      const query = window.App.transformQueryParams(lazyParams)
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "system-admin/girp-additional-field-collection" + query,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setTotalRecords(response?.data?.data?.total_item_count || 0);
          setCollections(response?.data?.data?.items || []);
          setLoading(false);
        })
        .catch(error => {
          setLoading(false);
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }, Math.random() * 1000 + 250);
  }

  const onPage = (event) => {
    setLazyParams({...lazyParams, ...event});
  }

  const onSort = (event) => {
    setLazyParams({...lazyParams, ...event});
  }

  const onFilter = (event) => {
    const nextLazyParams = {...lazyParams, ...event};
    nextLazyParams.first = 0;
    nextLazyParams.page = 0;
    setLazyParams(nextLazyParams);
  }

  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: 10, value: 10},
        {label: 20, value: 20},
        {label: 50, value: 50},
        {label: 200, value: 200}
      ];

      return (
        <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                  />
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', width: '120px', textAlign: 'center'}}>
          {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <>
        <Button icon="pi pi-eye" className="p-button-sm p-button-secondary p-mr-2"
                tooltip={t('show')}
                tooltipOptions={{position: 'left'}}
                onClick={() => {
                  navigate('/girp-additional-field-collection/read/' + rowData.id)
                }}/>
        <Button icon="pi pi-pencil" className="p-button-sm p-button-warning p-mr-2"
                tooltip={t('edit')}
                tooltipOptions={{position: 'left'}}
                onClick={() => {
                  navigate('/girp-additional-field-collection/update/' + rowData.id)
                }}/>
        <Button icon="pi pi-trash" className="p-button-sm p-button-danger"
                tooltip={t('delete')}
                tooltipOptions={{position: 'left'}}
                onClick={() => {
                  window.App.setState({[`confirmDeleteGirpCollection${rowData.id}`]: true})
                }}
        />
        <ConfirmDialog group="declarative" visible={window.App.state[`confirmDeleteGirpCollection${rowData.id}`]}
                       acceptLabel={t('yes')} rejectLabel={t('no')}
                       onHide={() => {
                         window.App.setState({[`confirmDeleteGirpCollection${rowData.id}`]: false})
                       }}
                       message={t('confirm_delete')} header={t('confirm_delete')} icon="pi pi-exclamation-triangle"
                       accept={() => {
                         window.App.delete('system-admin/girp-additional-field-collection', rowData.id)
                           .then(response => {
                             window.App.toastShow('success', t('success_delete'));
                             loadLazyData();
                           })
                           .catch(error => {
                             window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                           })
                       }}
                       reject={() => {
                         window.App.setState({[`confirmDeleteGirpCollection${rowData.id}`]: false})
                       }}/>
      </>
    );
  }

  useEffect(() => {
    if (lazyParams.filters) {
      if (document.getElementById('search')) {
        document.getElementById('search').value = '';
      }
      localStorage.setItem('girpAdditionalFieldCollection_filters', JSON.stringify(lazyParams.filters))
      if (lazyParams.sortField) {
        localStorage.setItem('girpAdditionalFieldCollection_sortField', lazyParams.sortField)
      }
      if (lazyParams.sortOrder) {
        localStorage.setItem('girpAdditionalFieldCollection_sortOrder', lazyParams.sortOrder)
      }
      if (lazyParams.first >= 0) {
        localStorage.setItem('girpAdditionalFieldCollection_first', lazyParams.first)
      }
      if (lazyParams.page >= 0) {
        localStorage.setItem('girpAdditionalFieldCollection_page', lazyParams.page)
      }
      if (lazyParams.rows) {
        localStorage.setItem('girpAdditionalFieldCollection_rows', lazyParams.rows)
        setRows(lazyParams.rows)
      }
    }
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderGirpAdditionalFieldCollectionList])

  return (
    <>
      <div className={"p-grid"}>
        <div className={"p-col-12 p-lg-5"}>
          <h2 className={"p-m-0"}>{t('girp_additional_field_collection_list')}</h2>
        </div>
        <div className={"p-col p-text-right p-col-align-center"}>
          {localStorage.getItem('girpAdditionalFieldCollection_filters') &&
            <a style={{color: "red"}} className={"p-button p-button-danger p-ml-2"}
               onClick={() => {
                 localStorage.removeItem('girpAdditionalFieldCollection_filters')
                 localStorage.removeItem('girpAdditionalFieldCollection_sortField')
                 localStorage.removeItem('girpAdditionalFieldCollection_sortOrder')
                 localStorage.removeItem('girpAdditionalFieldCollection_rows')
                 localStorage.removeItem('girpAdditionalFieldCollection_page')
                 localStorage.removeItem('girpAdditionalFieldCollection_first')
                 setLazyParams({
                   ...lazyParams,
                   filters: null,
                   first: 0,
                   page: 0,
                 })
               }}
            >
              <i className={"pi pi-exclamation-triangle"}></i>&nbsp;{t('clear_filter')}
            </a>
          }

          <span className="p-input-icon-left p-ml-2">
            <i className="pi pi-search"/>
            <InputText id="search"
                       placeholder={t('search')}
                       onChange={(e) => {
                         clearTimeout(window.searchTimeout)
                         window.searchTimeout = setTimeout(function () {
                           localStorage.removeItem('girpAdditionalFieldCollection_filters')
                           localStorage.removeItem('girpAdditionalFieldCollection_sortField')
                           localStorage.removeItem('girpAdditionalFieldCollection_sortOrder')
                           localStorage.removeItem('girpAdditionalFieldCollection_rows')
                           localStorage.removeItem('girpAdditionalFieldCollection_page')
                           localStorage.removeItem('girpAdditionalFieldCollection_first')
                           setLazyParams({
                             ...lazyParams,
                             genericSearch: e.target.value,
                             filters: null,
                             first: 0,
                             page: 0,
                           })
                         }, 1000)
                       }}
            />
          </span>
          <Button type="button" label={t('new_girp_additional_field_collection')} icon={"pi pi-plus"}
                  onClick={() => {
                    navigate('/girp-additional-field-collection/create')
                  }}
                  className="p-button-success p-ml-2"/>
        </div>
      </div>

      <DataTable
        ref={dt}
        size={"small"}
        emptyMessage={t('empty_message')}
        value={collections}
        paginator
        first={lazyParams.first}
        totalRecords={totalRecords}
        onPage={onPage}
        onSort={onSort}
        sortField={lazyParams.sortField}
        sortOrder={lazyParams.sortOrder}
        onFilter={onFilter}
        filters={lazyParams.filters}
        loading={loading}
        lazy
        paginatorTemplate={pager}
        rows={rows}
        autoLayout={true}
        filterDisplay="menu"
        responsiveLayout={window.App.state.responsiveLayout}
        breakpoint="1365px"
        stripedRows
        dataKey="id"
        selectionMode={"single"}
        onRowDoubleClick={(rowData) => {
          navigate('/girp-additional-field-collection/update/' + rowData.data.id)
        }}
      >
        
        <Column field="name" sortable header={t('name')}></Column>
        <Column field="description" sortable header={t('description')}></Column>
        <Column field="items" header={t('items')} body={(rowData) => (rowData?.items || []).length}></Column>
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-nowrap p-text-right"}></Column>
      </DataTable>
    </>
  )
}

export default withTranslation('common')(_FM_GirpadditionalfieldcollectionListComponent);
